import { MARQUEE_ITEMS } from "@/data/content";

export const Marquee = () => (
  <div
    className="overflow-hidden border-y border-charcoal/10 bg-paper py-6"
    data-testid="capabilities-marquee"
  >
    <div className="flex w-max animate-marquee">
      {[0, 1].map((dup) => (
        <div
          key={dup}
          className="flex shrink-0 items-center"
          aria-hidden={dup === 1}
        >
          {MARQUEE_ITEMS.map((item) => (
            <span key={`${dup}-${item}`} className="flex items-center">
              <span className="whitespace-nowrap px-8 font-heading text-base font-light uppercase tracking-[0.25em] text-navy/70">
                {item}
              </span>
              <span className="h-1.5 w-1.5 rotate-45 bg-gold" />
            </span>
          ))}
        </div>
      ))}
    </div>
  </div>
);
